import React, { useContext, useEffect, useMemo, useState } from "react";

import style from "./member.module.css";
import { UserAddOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Dropdown, Menu, Tooltip } from "antd";
import useFetch, { CachePolicies } from "use-http";
import { AppContext } from "src/pages/context/App.context";
import { useTranslation } from "react-i18next";
import styles from "../../../Home/Post/PostCard.module.scss";
import moreImg from "../../../../assets/png/more_2.png";
import { useAppSelector } from "src/hooks";
import { profile } from "src/features/profile/profileSlice";
import { MemberRole } from "../../../../constants/Member";
import UserProfile from "src/pages/ActionCenter/image/user_empty.png";

enum FRIEND_STATUS {
  NOT_CONNECT,
  CONNECTED,
  HAS_REQUESTED,
  PENDING,
}

export const promoteRole = {
  admin: "admin",
  owner: "owner",
  removeAdmin: "remove_admin",
  removeFromGroup: "remove_from_group",
  removeMember: "remove_member",
  removeOwner: "remove_owner"
};

const Member = (props: any) => {
  //props = {role, data, isGroup, community, context}
  const { myRole, role, data, isGroup, context } = props;
  const { t } = useTranslation();
  const myProfile = useAppSelector(profile);
  // const chatCtx: any = useContext(ChatContext);
  const appCtx: any = useContext(AppContext);
  const [mutual, setMutual]: any = useState([]);
  const [showOption, setShowOption] = useState(false);
  const [friendStatus, setFriendStatus] = useState(FRIEND_STATUS.CONNECTED);

  const friends = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/friends",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const mutualGroup = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v1/users/detail`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const requestStatus = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/status-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const addFriend = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/add-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const acceptFriend = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/accept-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const checkFriend = async () => {
    try {
      const isFriends = await friends.get(`?mode=add&search=${data?.id}`);
      const mutual = await mutualGroup.get(`/${data?.id}`);

      if (isFriends?.data.length === 0) {
        setFriendStatus(FRIEND_STATUS.NOT_CONNECT);
      } else if (isFriends?.data.length !== 0) {
        setFriendStatus(FRIEND_STATUS.CONNECTED);
      }

      setMutual(mutual?.mutualGroups ? mutual?.mutualGroups : []);
    } catch (error) {
      console.error(error);
    }
  };

  const connect = async () => {
    try {
      const res = await addFriend.post({ friendID: data.id });
      if (addFriend?.response?.ok) {
        if (res?.type === "request") {
          setFriendStatus(FRIEND_STATUS.PENDING);
        } else if (res?.type === "accept") {
          setFriendStatus(FRIEND_STATUS.CONNECTED);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const acceptRequest = async () => {
    try {
      await acceptFriend.post({ friendID: data.id });
      if (acceptFriend.response.ok) {
        setFriendStatus(FRIEND_STATUS.CONNECTED);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddFriend = async () => {
    try {
      const status = await requestStatus.get(`?id=${data.id}`);

      if (requestStatus.response.ok) {
        if (status?.friendID === data.id) {
          setFriendStatus(FRIEND_STATUS.PENDING);
        } else {
          await acceptRequest();
        }
      }

      if (status?.code === 500) {
        await connect();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    checkFriend();

    return () => {
      friends.abort();
      mutualGroup.abort();
      requestStatus.abort();
      addFriend.abort();
      acceptFriend.abort();
    };
  }, []);

  const handlePromoteMember = (role: string) => {
    setShowOption(false);
    context.setPromoteMember(role);
    context.setSelectedUserId([data?.id]);
  };

  const getMemberName = () => {
    if (!data?.firstname && !data?.lastname) return "unknown"
    return `${data?.firstname} ${data?.lastname ? data?.lastname : ""} ${isGroup ? `(${t(role)})` : ""
      }`;
  };

  const canRemoveAdmin: boolean = useMemo(() => {
    return myRole === MemberRole.OWNER && role === MemberRole.ADMIN
  }, [myRole, role])

  const canPromoteAdmin: boolean = useMemo(() => {
    return myRole === MemberRole.OWNER && role === MemberRole.MEMBER;
  }, [myRole, role])

  const canPromoteOwner: boolean = useMemo(() => {
    return myRole === MemberRole.OWNER && (role === MemberRole.ADMIN || role === MemberRole.MEMBER);
  }, [myRole, role])

  const canRemoveOwner: boolean = useMemo(() => {
    return myRole === MemberRole.OWNER && role === MemberRole.OWNER;
  }, [myRole, role])

  const canRemoveMember: boolean = useMemo(() => {
    return (myRole === MemberRole.OWNER || myRole === MemberRole.ADMIN) && role === MemberRole.MEMBER;
  }, [myRole, role])

  const renderOptions = useMemo(() => {
    // if ((canPromoteOwner || canPromoteAdmin || canRemoveAdmin || canRemoveMember) && isGroup && data?.id !== myProfile?.id) {
    //   return (
    //     <div className={style.option}>
    //       <div>
    //         <Dropdown
    //           overlay={
    //             <Menu>
    //               {canPromoteAdmin &&
    //                 <Menu.Item
    //                   className={styles.menuItem}
    //                   onClick={() => {
    //                     handlePromoteMember(promoteRole.admin);
    //                   }}
    //                 >
    //                   <div style={{ display: "flex" }}>
    //                     <div
    //                       style={{
    //                         margin: "auto",
    //                       }}
    //                     >
    //                       {t("Promote Admin")}
    //                     </div>
    //                   </div>
    //                 </Menu.Item>
    //               }
    //               {canPromoteOwner &&
    //                 <Menu.Item
    //                   className={styles.menuItem}
    //                   onClick={() => {
    //                     handlePromoteMember(promoteRole.owner);
    //                   }}
    //                 >
    //                   <div style={{ display: "flex" }}>
    //                     <div
    //                       style={{
    //                         margin: "auto",
    //                       }}
    //                     >
    //                       {t("Promote Owner")}
    //                     </div>
    //                   </div>
    //                 </Menu.Item>
    //               }
    //               {canRemoveAdmin &&
    //                 <Menu.Item
    //                   className={styles.menuItem}
    //                   onClick={() => {
    //                     handlePromoteMember(promoteRole.removeAdmin);
    //                   }}
    //                 >
    //                   <div style={{ display: "flex" }}>
    //                     <div
    //                       style={{
    //                         margin: "auto",
    //                       }}
    //                     >
    //                       {t("Remove Admin")}
    //                     </div>
    //                   </div>
    //                 </Menu.Item>
    //               }
    //               {canRemoveMember &&
    //                 <Menu.Item
    //                   className={styles.menuItem}
    //                   onClick={() => {
    //                     handlePromoteMember(promoteRole.removeFromGroup);
    //                   }}
    //                 >
    //                   <div style={{ display: "flex" }}>
    //                     <div
    //                       style={{
    //                         margin: "auto",
    //                       }}
    //                     >
    //                       {t("Remove User")}
    //                     </div>
    //                   </div>
    //                 </Menu.Item>
    //               }
    //             </Menu>
    //           }
    //           placement="bottomRight"
    //           arrow
    //           trigger={["click"]}
    //         >
    //           <img src={moreImg} width="20" style={{ cursor: "pointer" }} />
    //         </Dropdown>
    //       </div>
    //     </div>)
    // } else 
    if (myProfile.id !== data?.id && friendStatus === FRIEND_STATUS.NOT_CONNECT) {
      return (
        <UserAddOutlined
          style={{ fontSize: "1rem", color: "#C5C3C3", cursor: "pointer" }}
          onClick={handleAddFriend}
        />
      )
    } else if (myProfile.id !== data?.id && friendStatus === FRIEND_STATUS.PENDING) {
      return (
        <UserSwitchOutlined
          style={{
            fontSize: "1.2rem",
            color: "#C5C3C3",
            cursor: "pointer",
          }}
        />
      )
    }
  }, [friendStatus, myProfile, data, myRole, isGroup, role, canPromoteOwner, canPromoteAdmin, canRemoveAdmin, canRemoveMember])

  const option = (
    <div style={{ borderRadius: 8 }}>
      <p
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePromoteMember(promoteRole.admin);
        }}
      >
        {t("Promote Admin")}
      </p>
      <p
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePromoteMember(promoteRole.owner);
        }}
      >
        {t("Promote Owner")}
      </p>
      <p
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePromoteMember(promoteRole.removeAdmin);
        }}
      >
        {t("Remove Admin")}
      </p>
      <p
        style={{ cursor: "pointer" }}
        onClick={() => {
          handlePromoteMember(promoteRole.removeFromGroup);
        }}
      >
        {t("Remove User")}
      </p>
    </div>
  );
  return (
    <div className={props?.community ? style.memberCommunity : style.member}>
      <div className={style.leftSection}>
        {data?.imageProfileURL ?
          <div
            className={style.profileImage}
            style={{ backgroundImage: `url(${data?.imageProfileURL})` }}
          /> : <div
            className={style.profileImage}
            style={{ backgroundImage: `url(${UserProfile})` }}
          />
        }


        <div className={style.memberDetail}>
          <Tooltip
            placement={props?.community ? "topLeft" : "top"}
            title={getMemberName()}
            color="#0f4c82"
          >
            <div className={style.memberName}>{getMemberName()}</div>
          </Tooltip>
          {myProfile.username !== data?.id && (
            <div className={style.mutualGroup}>
              {mutual?.length !== 0
                ? `In ${mutual?.length} groups together`
                : `no mutual group`}
            </div>
          )}
        </div>
      </div>
      {renderOptions}
      {/*<div className={style.option}>*/}
      {/*  {(myRole === "admin" || myRole === "owner") &&*/}
      {/*  isGroup*/}
      {/*  ? (*/}
      {/*      <div>*/}
      {/*        <Dropdown*/}
      {/*            overlay={*/}
      {/*              <Menu>*/}
      {/*                <Menu.Item*/}
      {/*                    className={styles.menuItem}*/}
      {/*                    onClick={() => {*/}
      {/*                      handlePromoteMember(promoteRole.admin);*/}
      {/*                    }}*/}
      {/*                >*/}
      {/*                  <div style={{ display: "flex" }}>*/}
      {/*                    <div*/}
      {/*                        style={{*/}
      {/*                          margin: "auto",*/}
      {/*                        }}*/}
      {/*                    >*/}
      {/*                      {t("Promote Admin")}*/}
      {/*                    </div>*/}
      {/*                  </div>*/}
      {/*                </Menu.Item>*/}
      {/*                <Menu.Item*/}
      {/*                    className={styles.menuItem}*/}
      {/*                    onClick={() => {*/}
      {/*                      handlePromoteMember(promoteRole.owner);*/}
      {/*                    }}*/}
      {/*                >*/}
      {/*                  <div style={{ display: "flex" }}>*/}
      {/*                    <div*/}
      {/*                        style={{*/}
      {/*                          margin: "auto",*/}
      {/*                        }}*/}
      {/*                    >*/}
      {/*                      {t("Promote Owner")}*/}
      {/*                    </div>*/}
      {/*                  </div>*/}
      {/*                </Menu.Item>*/}
      {/*                <Menu.Item*/}
      {/*                    className={styles.menuItem}*/}
      {/*                    onClick={() => {*/}
      {/*                      handlePromoteMember(promoteRole.removeAdmin);*/}
      {/*                    }}*/}
      {/*                >*/}
      {/*                  <div style={{ display: "flex" }}>*/}
      {/*                    <div*/}
      {/*                        style={{*/}
      {/*                          margin: "auto",*/}
      {/*                        }}*/}
      {/*                    >*/}
      {/*                      {t("Remove Admin")}*/}
      {/*                    </div>*/}
      {/*                  </div>*/}
      {/*                </Menu.Item>*/}
      {/*                <Menu.Item*/}
      {/*                    className={styles.menuItem}*/}
      {/*                    onClick={() => {*/}
      {/*                      handlePromoteMember(promoteRole.removeFromGroup);*/}
      {/*                    }}*/}
      {/*                >*/}
      {/*                  <div style={{ display: "flex" }}>*/}
      {/*                    <div*/}
      {/*                        style={{*/}
      {/*                          margin: "auto",*/}
      {/*                        }}*/}
      {/*                    >*/}
      {/*                      {t("Remove User")}*/}
      {/*                    </div>*/}
      {/*                  </div>*/}
      {/*                </Menu.Item>*/}
      {/*              </Menu>*/}
      {/*            }*/}
      {/*            placement="bottomRight"*/}
      {/*            arrow*/}
      {/*            trigger={["click"]}*/}
      {/*        >*/}
      {/*          <img src={moreImg} width="20" style={{ cursor: "pointer" }} />*/}
      {/*        </Dropdown>*/}
      {/*      </div>*/}
      {/*  ) : myProfile.username !== data?.id &&*/}
      {/*  friendStatus === FRIEND_STATUS.NOT_CONNECT ? (*/}
      {/*      <UserAddOutlined*/}
      {/*          style={{ fontSize: "1rem", color: "#C5C3C3", cursor: "pointer" }}*/}
      {/*          onClick={handleAddFriend}*/}
      {/*      />*/}
      {/*  ) : (*/}
      {/*      myProfile.username !== data?.id &&*/}
      {/*      friendStatus === FRIEND_STATUS.PENDING && (*/}
      {/*          <UserSwitchOutlined*/}
      {/*              style={{*/}
      {/*                fontSize: "1.2rem",*/}
      {/*                color: "#C5C3C3",*/}
      {/*                cursor: "pointer",*/}
      {/*              }}*/}
      {/*          />*/}
      {/*      )*/}
      {/*  )}*/}
      {/*</div>*/}
    </div>
  );
};

export default Member;
